export default "__VITE_ASSET__BZnL27Lp__"